
export class MatInputValueChange {

  constructor(public newValue: any,
    public propertyName: string,
    public resource: any /*BillableEntityItem*/) { }

}
